<div class="my-list-wrapper">
  <app-search-bar
    [placeholder]="searchPlaceholder"
    [tooltip]="searchTooltip"
    (searchChanged)="filterAssistants($event)"
  ></app-search-bar>

  <app-loading-spinner *ngIf="loading"></app-loading-spinner>

  <div *ngIf="!loading" class="table-container">
    <div
      *ngIf="conversations && conversations.length > 0; else noConversations"
    >
      <app-data-table
        [data]="filteredConversations"
        [columns]="columns"
        [presentationMode]="presentationMode"
        [emptyMessage]="'No conversations found'"
        (rowClicked)="onRowClick($event)"
        (actionClicked)="onActionClick($event)"
      ></app-data-table>
    </div>

    <ng-template #noConversations>
      <app-chat-card
        class="no-conversations-card"
        *ngIf="!loading"
        [header]="''"
        [description]="'No previous conversations found'"
        [button_label]="'Start One'"
        [route]="'/chat'"
      >
      </app-chat-card>
    </ng-template>
  </div>

</div>
